// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"501":"7350c3f3","520":"19e11621","618":"b33fcd5a","751":"6a564ff6","983":"184cf282","997":"9580fc01"}[chunkId] + ".chunk.js";
};